import { render, staticRenderFns } from "./EditModalRole.vue?vue&type=template&id=7c09baff&scoped=true&"
import script from "./EditModalRole.vue?vue&type=script&lang=js&"
export * from "./EditModalRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c09baff",
  null
  
)

export default component.exports